import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n/i18n';
import 'mapbox-gl/dist/mapbox-gl.css';
import { initConfig } from './config/env';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

initConfig().then(() => {
    const root = ReactDOM.createRoot(
        document.getElementById('root') as HTMLElement
    );
    root.render(
        <App />
    );
    serviceWorkerRegistration.register();
}).catch((error) => {
    console.error("Error initializing config:", error);
});